import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
interface Notification {
  id: number;
  name: string;
  location: string;
  action: string;
  timeAgo: string;
}
const names = ['Sarah', 'Emily', 'Jessica', 'Michael', 'David', 'Amanda', 'Rachel'];
const locations = ['Texas', 'California', 'UK', 'Canada', 'Australia', 'New York', 'Florida'];
const actions = ['bought the bundle', 'started Texture Hacking', 'got the guide'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function LiveActivityPopup() {
  const [notification, setNotification] = useState<Notification | null>(null);
  useEffect(() => {
    const showNotif = () => {
      setNotification({
        id: Date.now(),
        name: getRandomItem(names),
        location: getRandomItem(locations),
        action: getRandomItem(actions),
        timeAgo: 'just now'
      });
      setTimeout(() => setNotification(null), 4000);
    };
    const interval = setInterval(showNotif, 15000);
    setTimeout(showNotif, 4000); // First one
    return () => clearInterval(interval);
  }, []);
  return <div className="fixed bottom-24 sm:bottom-4 left-4 z-40 max-w-[280px]" data-id="element-146">
      <AnimatePresence data-id="element-147">
        {notification && <motion.div initial={{
        opacity: 0,
        y: 20,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20
      }} className="bg-[var(--bg-card)] rounded-xl p-3 shadow-lg flex items-center gap-3 border border-[var(--border-subtle)]" data-id="element-148">
            <div className="w-10 h-10 rounded-full bg-[var(--accent-soft)] flex items-center justify-center flex-shrink-0 text-[var(--accent)]" data-id="element-149">
              <ShoppingBag className="w-5 h-5" data-id="element-150" />
            </div>
            <div data-id="element-151">
              <p className="text-xs text-[var(--text-heading)]" data-id="element-152">
                <span className="font-bold" data-id="element-153">{notification.name}</span> from{' '}
                {notification.location}
              </p>
              <p className="text-[10px] text-[var(--text-muted)] mt-0.5" data-id="element-154">
                {notification.action} • {notification.timeAgo}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}